import React from 'react'
import Divider from './Divider'

interface SheetHeaderProps {
  title: string
  /** 좌측 액션(예: 뒤로가기 화살표). 없으면 빈 슬롯으로 가운데 정렬 유지 */
  leftAction?: React.ReactNode
  /** 우측 액션(예: 완료/추가/복사 버튼) */
  rightAction?: React.ReactNode
  /** 제목 아래 전체폭 분할선 표시 (기본 true) */
  showDivider?: boolean
}

/**
 * 모든 바텀시트 공용 헤더. 멤버 초대 시트 디자인이 기준:
 *  [좌측 액션] — [제목(가운데)] — [우측 액션]  +  전체폭(양끝까지) 분할선
 * 좌/우 슬롯은 동일 최소폭이라 제목이 항상 가운데 정렬됨.
 */
const SheetHeader: React.FC<SheetHeaderProps> = ({
  title,
  leftAction,
  rightAction,
  showDivider = true,
}) => {
  return (
    <>
      <div className="w-full flex items-center min-h-48px">
        <div className="min-w-48px flex-shrink-0 flex items-center">
          {leftAction}
        </div>
        <div className="flex-1 font-pretendard font-700 text-16px leading-24px text-brown-80%-main text-center px-8px">
          {title}
        </div>
        <div className="min-w-48px flex-shrink-0 flex items-center justify-end">
          {rightAction}
        </div>
      </div>
      {showDivider && <Divider />}
    </>
  )
}

export default SheetHeader
